import Base64Utils from 'js-base64';

export default {

  /**
   * 设置token
   * @param {*} token 
   */
  setToken(token) {
    localStorage.setItem('token', token);
  },

  /**
   * 获取token
   * @returns token
   */
  getToken() {
    let token = localStorage.getItem('token');
    return !!token ? token : '';
  },

  /**
   * 清空本地缓存
   */
  clearAll() {
    localStorage.removeItem('token');
  },

  /**
   * 解析jwt
   */
  decodeToken() {
    let token = this.getToken();
    if (!!token) {
      let array = token.split('.');
      if (2 == array.length) {
        let pload = Base64Utils.Base64.decode(array[0]);
        return JSON.parse(pload);
      }
    }
    return null;
  }

}


// WEBPACK FOOTER //
// ./src/utils/localStorage.utils.js